export const MenuListArray2 = [
    {
        title: 'Home',
        to: './',	
    },
    {   
        title: 'All Products',	
        to: './book-shop-search',
    },
    // {   
    //     title: 'Test',	
    //     to: './Signup',
    // },
    {  
        title: 'International Curriculum',	
        to :'#',
        classsChange: 'sub-menu-down',		
        content: [
            {   
                title: 'CAIE',	
                to: './book-shop-search?q=caie',
            },
            {   
                title: 'IBO',	
                to: './book-shop-search?q=ibo',
            },
        ],  
    },
    {  
        title: 'School Kit',
        to: './xyuhsf',	
        // classsChange: 'sub-menu-down',		
        // content: [
        //     {
        //         title: 'EPS Bhopal',
              					
        //     },
        // ],  
    },
    {   
        title: 'About Us',	
        to: './about-us',
    },
    {
        title: 'Contact Us',	
        to: './contact-us',
    },
]